import React, {useState}  from "react";
import './cv.css';

import { BsBriefcaseFill, BsTrophyFill, BsClockFill, BsSunFill } from "react-icons/bs";
import { MdSchool} from "react-icons/md";

import allEvents from "../content/cv";

const CV = ({ events, dense }) => {

    // Defaults to every station; the home page passes in only the highlights.
    const cvdata = events || allEvents;

    const [bar, setBar] = useState();

    function getEventIcon(event){
        // Category-specific icons take precedence over the base work/education icon.
        if (event.category === "prizes"){
            return <BsTrophyFill></BsTrophyFill>;
        }
        if (event.category === "part-time"){
            return <BsClockFill></BsClockFill>;
        }
        if (event.category === "summer-school"){
            return <BsSunFill></BsSunFill>;
        }

        if (event.type === "education"){
            return <MdSchool></MdSchool>;
        }
        if (event.type === "work"){
            return <BsBriefcaseFill></BsBriefcaseFill>;
        }
    }


    return (
        <div className={dense ? "cv cv-dense" : "cv"}>
            <svg className="timeline">
                <line  x1="50%" y1="0%" x2="50%" y2="100%"></line>
            </svg>


            <div className="cv-events">

                {
                    cvdata.map(
                        (event, idx) => {
                            return (
                                <div className={idx % 2 === 0 ? "cv-event" : "cv-event flipped-order"}>
                                    <div className="cv-event-info">
                                        <div className="cv-event-logo">
                                            {event.icon && <img src={event.icon} alt={event.title}></img>}
                                        </div>
                                        <div className="cv-event-text">
                                            <div className="cv-event-title">{event.title}</div>
                                            <div className="cv-event-at">{event.at}</div>
                                        </div>
                                    </div>

                                    <div className="cv-event-marker">
                                        <svg>
                                            <circle className="event-circle" cx="50%" cy="50%"></circle>
                                        </svg>
                                        <div className="cv-event-icon">
                                            {getEventIcon(event)}
                                        </div>
                                    </div>
                                    
                                    <div className="cv-event-time">{event.from} - {event.to}</div>
                                </div>
                            )
                        }
                    )
                }

            </div>

        </div>
    )
};


export default CV